import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import ModalArtworkTile from 'components/ArtworkTile/components/ModalArtworkTile';
import BlurredModal from 'components/Modal/BlurredModal';
import Loader from 'components/Modal/Loader';
import { OWNERSHIP_RELEASED_MODAL } from 'constants/metrics';
import { PageContext } from 'contexts';
import useGetPodcastDetails from 'hooks/getPodcastDetails';
import { usePageView } from 'hooks/pageView';
import { modalPodcastIdSelector } from 'store/selectors/modal';
import './styles.scss';

const Title = (
  <h4>
    <FormattedMessage
      id="ownershipReleasedModal-title"
      defaultMessage="Ownership Released"
    />
  </h4>
);

const OwnershipReleasedModal = () => {
  const modalPodcastId = useSelector(modalPodcastIdSelector);
  const { podcastDetailsLoading } = useGetPodcastDetails(modalPodcastId);
  usePageView(OWNERSHIP_RELEASED_MODAL);

  return (
    <PageContext.Provider value={OWNERSHIP_RELEASED_MODAL}>
      {podcastDetailsLoading ? (
        <Loader />
      ) : (
        <BlurredModal title={Title}>
          <div className="OwnershipReleasedModal__content-container">
            <p className="bodyPrimary secondary-text">
              <FormattedMessage
                id="ownershipReleasedModal-description"
                defaultMessage="Released shows will continue to be available on Amazon Music. This show will remain on your dashboard until it is claimed by a new owner."
              />
            </p>
            <div className="OwnershipReleasedModal__artwork">
              <ModalArtworkTile />
            </div>
          </div>
        </BlurredModal>
      )}
    </PageContext.Provider>
  );
};

export default OwnershipReleasedModal;
